<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentEditMember /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentEditMember from '@/components/team/dashboard/modules/users/member/ContentEditMember.vue'

export default 
{
  name: 'EditMember',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentEditMember
  }
}
</script>
<style>


</style>